import DefaultWhenNullFormatter from '../../../components/grid-addons/formatters/DefaultWhenNullFormatter';
import MultiFormatter from './MultiFormatter';
import BreadcrumbFormatter from './BreadcrumbFormatter';
import AttributeWorkspaceFormatter from './AttributeWorkspaceFormatter';
import UrlFormatter from './UrlFormatter';
import CommentFormatter from './CommentFormatter';
import DocumentStatusFormatter from './DocumentStatusFormatter';
import ImageFormatter from './ImageFormatter';
import NumericFormatter from './NumericFormatter';
import LinkFormatter from './LinkFormatter';
import SelectedFormatter from './SelectedFormatter';
import BooleanFormatter from './BooleanFormatter';
import TextFieldFormatter from './TextFieldFormatter';
import DateFormatter from './DateFormatter';
import DateTimeFormatter from './DateTimeFormatter';
import FreeTypeDropdownFormatter from './FreeTypeDropdownFormatter';
import EnumFormatter from './EnumFormatter';
import AttributeFormatter from './AttributeFormatter';
import LotAttributeWorkspaceFormatter from './LotAttributeWorkspaceFormatter';
import DimensionFormatter from './DimensionFormatter';
import DurationFormatter from './DurationFormatter';
import DropdownFormatter from './DropdownFormatter';
import ExpandFormatter from './ExpandFormatter';
import SellingPriceFormatter from './SellingPriceFormatter';
import DeletedFormatter from './DeletedFormatter';
import ContextOptionsFormatter from './ContextOptionsFormatter';
import PaymentStatusFormatter from './PaymentStatusFormatter';
import ArrayFormatter from './ArrayFormatter';
import ExpansionFormatter from './ExpansionFormatter';
import PrimaryFieldFormatter from './PrimaryFieldFormatter';
import ChannelFormatter from './ChannelFormatter';
import PartNumberFormatter from './PartNumberFormatter';
import ReferenceWithSupplierPartNumberPillFormatter from './ReferenceWithSupplierPartNumberPillFormatter';
import CustomerOrSupplierFormatter from './CustomerOrSupplierFormatter';
import AmazonRefundFormatter from './AmazonRefundFormatter';
import CheckFormatter from './CheckFormatter';
import MaxoptraOrderPriority from './MaxoptraOrderPriorityFormatter';
import PopoverFormatter from './PopoverFormatter';
import ListSizeFormatter from './ListSizeFormatter';
import AttachmentsFormatter from './AttachmentsFormatter';
import ListFormatter from './ListFormatter';
import BadgeFormatter from './BadgeFormatter';
import ButtonFormatter from './ButtonFormatter';
import GenericListFormatter from './GenericListFormatter';

const Formatters = {
  ImageFormatter: ImageFormatter,
  NumericFormatter: NumericFormatter,
  LinkFormatter: LinkFormatter,
  UrlFormatter: UrlFormatter,
  SelectedFormatter: SelectedFormatter,
  BooleanFormatter: BooleanFormatter,
  TextFieldFormatter: TextFieldFormatter,
  PrimaryFieldFormatter: PrimaryFieldFormatter,
  DateFormatter: DateFormatter,
  DateTimeFormatter: DateTimeFormatter,
  FreeTypeDropdownFormatter: FreeTypeDropdownFormatter,
  EnumFormatter: EnumFormatter,
  AttributeFormatter: AttributeFormatter,
  AttributeWorkspaceFormatter: AttributeWorkspaceFormatter,
  LotAttributeWorkspaceFormatter: LotAttributeWorkspaceFormatter,
  DimensionFormatter: DimensionFormatter,
  DurationFormatter: DurationFormatter,
  DropdownFormatter: DropdownFormatter,
  ExpandFormatter: ExpandFormatter,
  SellingPriceFormatter: SellingPriceFormatter,
  DeletedFormatter: DeletedFormatter,
  ContextOptionsFormatter: ContextOptionsFormatter,
  DocumentStatusFormatter: DocumentStatusFormatter,
  PaymentStatusFormatter: PaymentStatusFormatter,
  ArrayFormatter: ArrayFormatter,
  ExpansionFormatter: ExpansionFormatter,
  MultiFormatter: MultiFormatter,
  PartNumberFormatter: PartNumberFormatter,
  ChannelFormatter: ChannelFormatter,
  BreadcrumbFormatter: BreadcrumbFormatter,
  DefaultWhenNullFormatter,
  ReferenceWithSupplierPartNumberPillFormatter: ReferenceWithSupplierPartNumberPillFormatter,
  CustomerOrSupplierFormatter: CustomerOrSupplierFormatter,
  AmazonRefundFormatter: AmazonRefundFormatter,
  CommentFormatter: CommentFormatter,
  CheckFormatter: CheckFormatter,
  MaxoptraOrderPriority: MaxoptraOrderPriority,
  PopoverFormatter: PopoverFormatter,
  ListSizeFormatter: ListSizeFormatter,
  AttachmentsFormatter: AttachmentsFormatter,
  ListFormatter: ListFormatter,
  BadgeFormatter: BadgeFormatter,
  ButtonFormatter: ButtonFormatter,
  GenericListFormatter: GenericListFormatter,
};

export default Formatters;
